class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener("click", async function (event) {
    const upgradeBtn = event.target.closest(".btn_upgrade");
    if (!upgradeBtn) return;

    const wrapper = upgradeBtn.closest(".upgrade_bundle--wrapper");
    if (!wrapper) return;

    const offer = wrapper.querySelector(".upgrade_offer");
    if (!offer) return;

    const itemKey = offer.dataset.itemId;
    const targetPlan = offer.dataset.targetPlan;
    const analyticsId = offer.dataset.analyticsId || "";

    // Disable button + loading UI
    upgradeBtn.disabled = true;
    const originalText = upgradeBtn.textContent.trim();
    upgradeBtn.textContent = "Updating…";

    try {
      // 1️⃣ Get current cart state
      const cartResponse = await fetch("/cart.js");
      const cartData = await cartResponse.json();

      const cartItem = cartData.items.find(item => item.key === itemKey);
      if (!cartItem) throw new Error("Cart item not found");

      const existingProps = cartItem.properties || {};
      const updatedProps = {
        ...existingProps,
        "__appstle-selected-selling-plan": targetPlan,
        "__pf_analytics_orderitem_id": analyticsId
      };

      const payload = {
        id: itemKey,
        selling_plan: parseInt(targetPlan, 10),
        properties: updatedProps
      };

      // 2️⃣ Send the change request
      const changeResponse = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const changeData = await changeResponse.json();
      console.log("Update success:", changeData);

      // 3️⃣ Fetch updated cart page HTML
      const html = await fetch(window.location.pathname).then(r => r.text());
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      // 4️⃣ Unified sections list
      const mainSections = [
        // 🛒 Cart Page
        { id: "main-cart-items", selector: ".js-contents" },
        { id: "cart-live-region-text", selector: ".shopify-section" },
        { id: "main-cart-footer", selector: ".js-contents" },
        { id: "cart-drawer", selector: "#CartDrawer" },
        { id: "CartDrawer", selector: ".drawer__inner" },
        { id: "cart-icon-bubble", selector: ".shopify-section" }
      ];

      // Update all sections if present
      mainSections.forEach(({ id, selector }) => {
        const newHTML = doc.getElementById(id)?.querySelector(selector)?.innerHTML;
        const existingEl = document.getElementById(id)?.querySelector(selector) ||
                           document.querySelector(`#${id} ${selector}`);

        if (newHTML && existingEl) {
          existingEl.innerHTML = newHTML;
        }
      });

      // 5️⃣ Re‑trap focus for drawer if it’s open
      const drawerEl = document.querySelector("cart-drawer.active");
      if (drawerEl) {
        const focusTarget = drawerEl.querySelector(".drawer__inner") || drawerEl.querySelector(".drawer__close");
        trapFocus(drawerEl, focusTarget); 
      }

      // 6️⃣ Restore button UI
      upgradeBtn.disabled = false;
      upgradeBtn.textContent = originalText;

    } catch (error) {
      console.error("Error updating:", error);

      // Restore button state if error
      upgradeBtn.disabled = false;
      upgradeBtn.textContent = originalText;
    }
  });
});

